class HelptapUserInterface {

  constructor(apiClient, userId) {

    this.apiClient = apiClient;
    this.basePath = `/users/${userId}`;

  }

  async getProfile() {

    const path = this.basePath + '/basic-profile';

    return this.apiClient.get(path);

  }

  async updateUserProfilePictureById(file) {

    const path = this.basePath + '/profile-picture';

    const data = new FormData();
    data.append('file', file);

    return this.apiClient.put(path, {}, {}, data, true);
  }

  async updateUserProfileById(data) {

    const path = this.basePath + '/basic-profile';

    return this.apiClient.put(path, {}, {}, data);
  }

  async validateUpdateUserProfileByIdInput(data) {

    const path = this.basePath + '/basic-profile/validate';

    return this.apiClient.put(path, {}, {}, data);

  }

  async getAllStartups() {

    const path = this.basePath + '/startups';

    return this.apiClient.get(path);

  }

  async getAssociatedStartups() {

    const path = this.basePath + '/recent-startups';

    return this.apiClient.get(path);

  }

  async getAllAssociatedStartups() {

    const path = this.basePath + '/all-startups';

    return this.apiClient.get(path);

  }

  async canCreateNewStartups() {

    const path = this.basePath + '/can-create-new-startups';

    return this.apiClient.get(path);

  }

  async createStartupDraft() {

    const path = this.basePath + '/startups';

    return this.apiClient.post(path, {}, {}, {});

  }

  async setBasicDetailsByStartupId(startupId, basicDetails) {

    const path = this.basePath + '/startups/:startupId';

    return this.apiClient.put(path, { startupId }, {}, basicDetails);

  }

  async uploadStartupIconFile(startupId, icon) {

    const path = this.basePath + '/startups/:startupId/icon-file';

    const data = new FormData();
    data.append('file', icon);

    return this.apiClient.put(path, { startupId }, {}, data, true);

  }

  async updateStartupIconURLById(startupId, iconImageId) {

    const path = this.basePath + '/startups/:startupId/icon-url';

    const data = {
      iconImageId
    };

    return this.apiClient.put(path, { startupId }, {}, data);

  }

  async validateSetBasicDetailsByStartupIdInput(startupId, basicDetails) {

    const path = this.basePath + '/startups/:startupId/validate';

    return this.apiClient.put(path, { startupId }, {}, basicDetails);

  }

  async getStartupById(startupId) {

    const path = this.basePath + '/startups/:startupId';

    return this.apiClient.get(path, { startupId });

  }

  async getStartupWithAccessCodeByOwnerId(startupId) {

    const path = this.basePath + '/startup-with-access-code/:startupId';

    return this.apiClient.get(path, { startupId });

  }

}

export default HelptapUserInterface;